









































import { Component, InjectReactive, Vue } from 'vue-property-decorator';

import { faultsTableFields } from '@/models/faults-table-fields';
import { FeedProduct } from '../../models';
import { BvTableFieldArray } from 'bootstrap-vue';

@Component({})
export default class FeedProductFaultsTab extends Vue {
	@InjectReactive('feedProduct')
	public feedProduct!: FeedProduct;

	public get faultFields(): BvTableFieldArray {
		return faultsTableFields;
	}
}
